import { Button, Modal } from '@hakimo-ui/shared/ui-base';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

interface Props {
  open: boolean;
  email: string;
  onClose: () => void;
}

export function ResetPasswordSentModal(props: Props) {
  const { open, email, onClose } = props;

  return (
    <Modal open={open} onClose={onClose} closable={false}>
      <div className="w-96 px-8 py-6" data-testid="reset-password-sent-modal">
        <div className="bg-primary-800/10 mx-auto flex h-16 w-16 items-center justify-center rounded-full">
          <EnvelopeIcon className="text-primary-800 dark:text-primary-500 h-8 w-8" />
        </div>
        <h1 className="text-onlight-text-1 dark:text-ondark-text-1 mt-4 text-center text-lg font-medium">
          Check your inbox
        </h1>
        <p className="text-onlight-text-2 dark:text-ondark-text-2 mt-1 text-center text-sm">
          We've sent a password reset link to{' '}
          <span className="text-onlight-text-1 dark:text-ondark-text-1 break-words font-medium">
            {email}
          </span>
          . Open it to choose a new password.
        </p>
        <p className="text-onlight-text-3 dark:text-ondark-text-2 mt-3 text-center text-xs">
          Didn't get it? Check your spam folder or try again in a few minutes.
        </p>
        <div className="mt-6">
          <Button variant="primary" onClick={onClose} block autoFocus>
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ResetPasswordSentModal;
